import React from 'react'
import {
  CustomType,
  DivisionCategoryRow,
  DivisionCategoryType,
  GoalWithProgress,
  Lang,
  ProgressType,
  UserCustomDailyProgress,
  UserDailyDiaryProgress,
  UserDailyProgress,
} from '../../services/api.types'
import { c, msgid, ngettext, t } from 'ttag'
import { formatThousands } from '../../common/helpers/translations'
import { getCustomTypeText } from '../../services/CustomTypes'
import { getChallengeDurationInDays } from '../../common/helpers/date'
import {
  calculateProgressPercentage,
  ChallengeGoalType,
  getChallengeGoalUnits,
  getChallengeProgressCurrently,
  getChallengeProgressGoal,
  getChallengeProgressUnits,
  getPersistenceDailyTotal,
  isActivityIndexType,
  isCollectiveType,
  isDistanceType,
  isPersistenceType,
  parseGoalsConfig,
  getGoalConfigByType,
  getAvgSuffix,
} from '../../common/helpers/challenges'
import YumGrid from '../YumGrid/YumGrid'
import {
  darkBlue,
  darkGreen,
  challengeGoalGreen,
  challengeGoalYellow,
  bgGray,
  challengeGoalGray,
  whiteForDarkBackground,
} from '../../styles/material-ui-theme-v2'
import { currentLang, isRtl } from '../../i18nInit'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { GoalConfig } from '../../views/ChallengeAdmin/ChallengeAdmin'
import { ActivityView } from '../../views/Activity/store/ActivityReducer'
import YumConsistencyPillsCompact from './components/YumConsistencyPills/YumConsistencyPillsCompact'
import YumManualEntryButtonAndDetailsWrapper from '../YumCustomEntry/YumManualEntryButtonAndDetailsWrapper'
import { ConsistencyProgress } from './components/YumConsistencyPills/YumConsistencyPills'
import { Grid } from '@material-ui/core'

// Re-export GoalType from challenges helper for backward compatibility
export type GoalType = ChallengeGoalType

// Returns the background color for a goal card based on goal type and category.
// export const getGoalCardColor = (goalType?: GoalType, categoryType?: DivisionCategoryType): string => {
//   // Default color (same as darkBlue for backward compatibility)
//   const defaultColor = darkBlue

//   // Base goal type colors
//   const goalTypeColors: Record<GoalType, string> = {
//     individual: '#CDE7FF',
//     team: '#CFF7E8',
//     country: '#FFD8D4',
//     collective: '#E4E8F1',
//     group: '#E4E8F1', // Default for group, overridden by categoryType
//   }

//   // Division category colors for custom groups
//   const categoryColors: Record<DivisionCategoryType, string> = {
//     [DivisionCategoryType.AREA]: '#E8DEFF',
//     [DivisionCategoryType.CLUB]: '#FFF2C9',
//     [DivisionCategoryType.DEPARTMENT]: '#FFE2F3',
//     [DivisionCategoryType.DIVISION]: '#D5F7FA',
//     [DivisionCategoryType.LOCATION]: '#FFE3D2',
//     [DivisionCategoryType.REGION]: '#DDE4FF',
//     [DivisionCategoryType.CUSTOM]: '#F0E8FF',
//   }

//   // If no goal type is provided, return the default color
//   if (!goalType) {
//     return defaultColor
//   }

//   // For 'group' type, use category-specific color if categoryType is provided
//   if (goalType === 'group' && categoryType) {
//     return categoryColors[categoryType] || goalTypeColors.group
//   }

//   // Return the color for the goal type
//   return goalTypeColors[goalType] || defaultColor
// }

export interface IYumChallengeGoalCompactProps {
  goal: GoalWithProgress
  dailyDiary: UserDailyDiaryProgress[]
  customProgress?: UserCustomDailyProgress[]
  progressResults: UserDailyProgress[]
  isLeaderboard: boolean
  /** Activity view to determine which goal type to display */
  activityView?: ActivityView | string
  goalType?: GoalType
  groupCategoryId?: string
  /** Division category type for custom group styling (Areas, Clubs, etc.) */
  categoryType?: DivisionCategoryType
  /** Division categories for custom group lookups */
  divisionCategories?: DivisionCategoryRow[]
}

const useStyles = makeStyles((theme) => ({
  main: {
    //padding: '12px 16px 12px 16px',
    padding: '16px',
    //borderTopLeftRadius: '8px',
    //borderTopRightRadius: '8px',
    borderRadius: '8px',
    marginBottom: '8px',
    //color: 'white',
    fontSize: '14px',
    position: 'relative',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    //gap: 10,
    //borderBottomLeftRadius: 8,
    //borderBottomRightRadius: 8,
    //marginBottom: '32px',
    userSelect: 'none',
    height: '17px',
    lineHeight: '17px',
  },
  manualEntryButtonWrapper: {
    position: 'relative',
    zIndex: 2,
    marginRight: '-16px',
    marginTop: '-14px',
    paddingLeft: '3px',
    paddingBottom: '3px',
    height: '35px',
  },
  manualEntryButton: {
    position: 'relative',
    zIndex: 3,
  },
  manualEntryCutout: {
    // Creates the rounded cut-out shape behind the manual entry button.
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    //right: isRtl ? 'auto' : 0,
    //left: isRtl ? 0 : 'auto',
    //width: '140px',
    //height: '56px',
    backgroundColor: bgGray,
    borderBottomLeftRadius: '8px',
    //borderTopRightRadius: '8px',
    pointerEvents: 'none',
  },
  headerIcon: {
    flexShrink: 0,
    marginRight: isRtl ? 0 : '10px',
    marginLeft: isRtl ? '10px' : 0,
  },
  totalGoalLabel: {
    fontWeight: 500,
    //fontSize: 12,
    lineHeight: '14px',
  },
  totalGoalText: {
    fontWeight: 500,
    //fontSize: 15,
    lineHeight: '18px',
  },
  progressCurrently: {
    // fontWeight: 500,
    // fontSize: 28,
    // lineHeight: '33px',
  },
  progressGoal: {
    // fontWeight: 500,
    // fontSize: 28,
    // lineHeight: '33px',
    // opacity: 0.8,
  },
  progressUnits: {
    // fontWeight: 500,
    // fontSize: 18,
    // lineHeight: '21px',
    //opacity: 0.8,
    //color: '#495881',
  },
  progressBar: {
    borderRadius: '8px',
    height: '6px',
    //background: 'rgba(255, 255, 255, 0.4)',
    marginTop: '12px',
    marginBottom: '12px',
    //background: 'white',
    //backgroundColor: 'rgba(0, 0, 0, 0.18)',
    //opacity: '0.55',
  },
  progressBarBg: {
    backgroundColor: 'rgba(230, 235, 245, 0.18)',
  },
  progressBarInner: {
    borderRadius: '8px',
    height: '6px',
    marginTop: '8px',
    background: darkBlue,
    transition: 'all 0.2s ease-out',
  },

  footer: {
    display: 'flex',
    //gap: 10,
    flexDirection: 'column',
    position: 'relative',
    //padding: '10px',
    //borderBottomLeftRadius: '8px',
    //borderBottomRightRadius: '8px',
  },
  footerInner: {
    display: 'flex',
    justifyContent: 'space-between',
    //gap: 10,
    fontWeight: 600,
    //fontSize: '13px',
    lineHeight: '16px',
  },
  challengeLength: {
    paddingTop: '1px',
  },
  footerButton: {
    display: 'inline-block',
    padding: '0 8px',
    lineHeight: '16px',
    //fontSize: 12,
    fontWeight: 'bold',
    borderRadius: 6,
    width: 'auto',
    minWidth: 'auto',
    margin: 0,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    height: '20px',
  },
}))

export default function YumChallengeGoalCompact(props: IYumChallengeGoalCompactProps) {
  const classes = useStyles()
  const {
    goal,
    dailyDiary,
    customProgress,
    progressResults,
    isLeaderboard,
    activityView,
    divisionCategories = [],
    //goalType: goalTypeProp,
    //groupCategoryId: groupCategoryIdProp,
    //categoryType,
  } = props

  // Derive goalType and groupCategoryId from activityView if provided
  // This maps ActivityView to the appropriate goal type
  let goalType: GoalType | undefined = undefined
  let groupCategoryId: string | undefined = undefined

  if (activityView) {
    // Check if this is a DivisionCategory view (e.g., "DIVISION_CATEGORY_abc123")
    const isDivisionCategoryView = typeof activityView === 'string' && activityView.startsWith('DIVISION_CATEGORY_')

    if (isDivisionCategoryView) {
      goalType = 'group'
      groupCategoryId = activityView.replace('DIVISION_CATEGORY_', '')
    } else {
      // Map standard activity views to goal types
      switch (activityView) {
        case ActivityView.INDIVIDUAL:
          goalType = 'individual'
          break
        case ActivityView.GROUP:
          goalType = 'team'
          break
        case ActivityView.COUNTRY:
          goalType = 'country'
          break
        case ActivityView.COLLECTIVE:
          goalType = 'collective'
          break
        default:
          goalType = undefined
      }
    }
  }

  // Get categoryType from divisionCategories using groupCategoryId
  let categoryType: DivisionCategoryType | undefined = undefined
  if (groupCategoryId) {
    categoryType = divisionCategories.find((category) => category.id === groupCategoryId)?.type
  }

  // Parse and extract goal-specific configuration based on goalType
  // If goalType is not provided, uses the main goal (backward compatible)
  const goalsConfig = parseGoalsConfig(goal.goals)
  let goalConfig = getGoalConfigByType(goalsConfig, goalType, groupCategoryId)

  // Add type and groupCategoryId metadata to the config for downstream use
  if (goalConfig) {
    goalConfig = {
      ...goalConfig,
      type: goalType,
      ...(goalType === 'group' && groupCategoryId ? { groupCategoryId } : {}),
    } as GoalConfig
  }

  // Use goal config values if available, otherwise fall back to main goal values
  // This allows the component to work with both old and new goal structures
  const {
    id: goalId,
    customName,
    customType,
    customUnit,
    customGoal: mainCustomGoal,
    persistenceGoal: mainPersistenceGoal,
    dailyPersistenceGoal: mainDailyPersistenceGoal,
    progressType,
    participating,
    startDate,
    endDate,
    activityFormulaTarget: mainActivityFormulaTarget,
    collectivePercentage,
    manualEntryEnabled,
    stepsGoal: mainStepsGoal,
  } = goal

  // Helper function to convert GoalConfig value (number | '') to number or null
  const getNumericValue = (value: number | ''): number | null => {
    return value !== '' && typeof value === 'number' ? value : null
  }

  // Use goal config values when available, otherwise use main goal values
  const customGoal = goalConfig?.totalGoal ? (getNumericValue(goalConfig.totalGoal) ?? mainCustomGoal) : mainCustomGoal
  const persistenceGoal = goalConfig?.persistenceGoal
    ? (getNumericValue(goalConfig.persistenceGoal) ?? mainPersistenceGoal)
    : mainPersistenceGoal
  // const dailyPersistenceGoal = goalConfig?.dailyGoal
  //   ? (getNumericValue(goalConfig.dailyGoal) ?? mainDailyPersistenceGoal)
  //   : mainDailyPersistenceGoal
  const dailyPersistenceGoal = mainDailyPersistenceGoal
  const activityFormulaTarget = goalConfig?.indexTarget
    ? (getNumericValue(goalConfig.indexTarget) ?? mainActivityFormulaTarget)
    : mainActivityFormulaTarget
  const stepsGoal = goalConfig?.totalGoal ? (getNumericValue(goalConfig.totalGoal) ?? mainStepsGoal) : mainStepsGoal
  // Create a modified goal object with goal-specific values for helper functions
  // This allows us to reuse existing helper functions while using goal config values
  const goalWithConfig: GoalWithProgress = {
    ...goal,
    customGoal: customGoal ?? null,
    persistenceGoal: persistenceGoal ?? null,
    dailyPersistenceGoal: dailyPersistenceGoal ?? null,
    activityFormulaTarget: activityFormulaTarget ?? null,
    stepsGoal: stepsGoal ?? 0,
  }

  //const isPersistenceCustom = progressType === ProgressType.PERSISTENCE_CUSTOM
  const isPersistenceCustomOrBinary =
    progressType === ProgressType.PERSISTENCE_CUSTOM || progressType === ProgressType.PERSISTENCE_CUSTOM_BINARY
  //const isCustom = isCustomType(progressType)
  const isCustomCustom = customType === CustomType.CUSTOM
  const isDailyGoalType = isPersistenceType(progressType) && goalType === 'individual'
  const isActivityIndex = isActivityIndexType(progressType)
  const isTotalActivityIndex = [ProgressType.ALL].includes(progressType)
  //const isPersistenceOrCustom = isDailyGoalType || isCustom

  //const customUnits = getCustomUnitText(customType, customType, customUnit) as string
  const daysNumber = getChallengeDurationInDays(startDate, endDate)

  const isDistance = isDistanceType(customType)
  //const isAutomated = isAutomatedType(customType)
  const isBinary = progressType === ProgressType.PERSISTENCE_CUSTOM_BINARY

  // Build the title combining goal type label and goal value
  const getTitle = (): string => {
    let label = ''
    let value: string | null = null

    if (!goalConfig?.enabled) {
      // No goal - Show activity name
      label = getCustomTypeText(customType, customName) || ''
      if (isActivityIndex) {
        label = t`Activity index`
      }
    } else {
      //console.log('isDailyGoalType', isDailyGoalType, 'isLeaderboard', isLeaderboard)
      //if (isDailyGoalType && isLeaderboard) {
      if (isPersistenceType(progressType) && isLeaderboard) {
        label = t`Goal`

        const persistenceGoalValue =
          typeof goalConfig.persistenceGoal === 'number' && goalConfig.persistenceGoal > 0
            ? goalConfig.persistenceGoal
            : null
        if (persistenceGoalValue && persistenceGoalValue > 0) {
          label +=
            ': ' +
            activityName +
            ' · ' +
            persistenceGoalValue +
            ' ' +
            ngettext(msgid`day`, `days`, persistenceGoalValue)
          // label +=
          //   ': ' +
          //   (currentLang === Lang.EN
          //     ? t`Achieve daily goal for ${persistenceGoalValue} days`
          //     : t`Achieve daily target for ${persistenceGoalValue} days`)
        }
      } else {
        // Get goal type label: "Daily goal" or "Goal"
        label = isDailyGoalType ? t`Daily goal` : t`Goal`

        // Get goal value with units
        let units = getChallengeGoalUnits(goalWithConfig)
        if (isTotalActivityIndex) {
          value = t`Activity index` + ' ' + `${goalValueFormatted}%`
        } else if (isDailyGoalType) {
          units = isActivityIndex ? units : ' ' + units
          value = dailyGoal ? `${formatThousands(dailyGoal)}${units}` : activityName || null
        } else {
          units = isPersistenceType(progressType) ? ngettext(msgid`day`, `days`, goalValue || 0) : units
          value = `${goalValueFormatted} ${units}`
        }
      }
    }

    // let groupSum = true
    // if (/*goalConfig &&*/ goalType !== 'individual' && goalType !== 'collective') {
    //   //groupSum = goalConfig.groupSum !== undefined && goalConfig.groupSum !== null ? goalConfig.groupSum : true
    //   groupSum = !goal.avgAgg
    // }
    // if (!groupSum) {
    //   if (value == null) {
    //     label = `${label} (${c('short').t`AVG`})`
    //   } else {
    //     value = `${value} (${c('short').t`AVG`})`
    //   }
    // }

    const avgText = getAvgSuffix(goalType as GoalType, goal.avgAgg)
    if (avgText) {
      if (value == null) {
        label = `${label} ${avgText}`
      } else {
        value = `${value} ${avgText}`
      }
    }

    return value ? `${label}: ${value}` : label
  }

  //let dailyGoal = isDailyGoalType ? goalConfig?.dailyGoal || 1 : null
  let dailyGoal = isDailyGoalType ? dailyPersistenceGoal || 1 : null
  // TODO: WRONG FOR DAILY GOAL TYPE
  if (isActivityIndex && !isDailyGoalType) dailyGoal = goalConfig?.indexTarget ? goalConfig.indexTarget : null

  const getPillsProgress = (manualEntryEnabled: boolean, dailyGoal: number): ConsistencyProgress[] => {
    //const dailyGoal = isBinary || dailyPersistenceGoal === null ? 1 : dailyPersistenceGoal || 0
    if (isActivityIndex) {
      return progressResults.length !== daysNumber
        ? []
        : progressResults.map((item, keyIndex) => {
            const total = getPersistenceDailyTotal(item, progressType, manualEntryEnabled)
            const { date } = item
            const achieved = total >= dailyGoal && participating
            return { date, achieved }
          })
    } else if (isCustomCustom || isPoints) {
      //console.log('customProgress', customProgress, customProgress.length, daysNumber)
      return customProgress?.length !== daysNumber
        ? []
        : customProgress.map((item, keyIndex) => {
            const { date, value } = item
            const achieved = value >= dailyGoal && participating
            return { date, achieved }
          })
    } else {
      //console.log('dailyDiary', dailyDiary)
      return dailyDiary?.length !== daysNumber
        ? []
        : dailyDiary.map((item, keyIndex) => {
            const { date, sum, integrationValue } = item
            const achieved = (manualEntryEnabled ? sum >= dailyGoal : integrationValue >= dailyGoal) && participating
            return { date, achieved }
          })
    }
  }

  // const isActivityIndex = progressType === ProgressType.ALL
  //const isCollective = isCollectiveType(progressType)
  const isCollective = goalType === 'collective'
  const isPoints = customType === CustomType.POINTS
  // console.log('isPoints', isPoints, customType)

  const showDigits = isDistance && !isCollective && !isPersistenceCustomOrBinary ? 2 : undefined

  // IMPORTANT NUMBERS SHOWN
  const progressValue = getChallengeProgressCurrently(goal, goalType, groupCategoryId)
  const goalValue = getChallengeProgressGoal(goalWithConfig)

  // TODO: New function for compact progress goal
  const goalValueFormatted = formatThousands(goalValue)
  const progressUnit = getChallengeProgressUnits(goalWithConfig)
  const progressPercentage = calculateProgressPercentage(progressValue, goalValue)
  // --- //

  const hasGoal = goalConfig?.enabled
  const showProgress = isCollective || !isLeaderboard
  const goalAchieved = hasGoal && progressPercentage >= 100 && showProgress

  const isTotalPoints = customType === CustomType.TOTAL_POINTS

  const activityName = isTotalActivityIndex
    ? t`Activity index`
    : isTotalPoints
      ? getCustomTypeText(CustomType.POINTS)
      : getCustomTypeText(customType, customName)

  const pillsProgress = isDailyGoalType ? getPillsProgress(manualEntryEnabled, dailyGoal || 0) : null

  const isCollectiveNoGoal = !hasGoal && isCollective
  // If goalType is specified but goal config is not enabled or doesn't exist, don't render
  // if (goalType && (!goalConfig || !goalConfig.enabled)) {
  //   return null
  // }

  // Manual entry button with wrapper that auto-provides userDto, hasRoleInCompany, isManualEntryInProgress
  const manualEntryButton = <YumManualEntryButtonAndDetailsWrapper goal={goal} compact={true} isMeView={true} />

  // Title text showing goal type and value
  const title = getTitle()

  if (!hasGoal && !isCollective) {
    return null
  }

  //const cardBgColor = hasGoal ? (goalAchieved ? challengeGoalGreen : challengeGoalYellow) : bgLightGray
  const cardBgColor = hasGoal || isCollective ? (goalAchieved ? challengeGoalGreen : darkBlue) : challengeGoalGray
  const isDarkBackground = (hasGoal || isCollective) && !goalAchieved

  const spacer = isActivityIndex && !isDailyGoalType ? '' : ' '

  return (
    <div>
      <div
        className={classes.main}
        style={{
          backgroundColor: cardBgColor,
          borderRadius: '8px',
          color: !(hasGoal || isCollective) || goalAchieved ? darkBlue : whiteForDarkBackground,
        }}
      >
        {/* Progress header */}
        {!isCollectiveNoGoal && (
          <div className={classes.header}>
            <Grid container justifyContent="space-between" alignContent="center" wrap="nowrap" alignItems="center">
              <Grid item style={{ position: 'relative', width: '100%' }}>
                {title}
              </Grid>
            </Grid>
          </div>
        )}

        {/* Progress text */}
        {showProgress && (
          <>
            {/* Progress bar */}
            {isCollectiveNoGoal ? null : isDailyGoalType ? (
              <div className={classes.progressBar}>
                {/* <div className={classes.footerInner}>
              <span className={classes.challengeLength}>{t`Challenge length: ${daysNumber} days`}</span>
            </div> */}
                {pillsProgress && pillsProgress.length > 0 ? (
                  <YumConsistencyPillsCompact
                    progress={pillsProgress}
                    darkBg={isDarkBackground}
                    isParticipating={participating}
                  />
                ) : null}
              </div>
            ) : (
              <div className={`${classes.progressBar} ${classes.progressBarBg}`}>
                {hasGoal && (
                  <div
                    className={classes.progressBarInner}
                    style={{
                      width: `${progressPercentage > 100 ? 100 : progressPercentage}%`,
                      //backgroundColor: goalAchieved ? darkGreen : darkBlue,
                      backgroundColor: !hasGoal || goalAchieved ? darkGreen : whiteForDarkBackground,
                    }}
                  />
                )}
              </div>
            )}
            <YumGrid>
              <div>
                <span className={classes.progressCurrently}>{formatThousands(progressValue, showDigits)}</span>
                {!hasGoal || (!isDailyGoalType && !isTotalActivityIndex) ? (
                  <>
                    <span className={classes.progressUnits}> {progressUnit}</span>
                  </>
                ) : (
                  <>
                    <span className={classes.progressGoal}> / {goalValueFormatted}</span>
                    {spacer}
                    <span className={classes.progressUnits}>{progressUnit}</span>
                  </>
                )}
              </div>
              {hasGoal && !isTotalActivityIndex && (
                <div style={{ whiteSpace: 'nowrap', height: '17px', lineHeight: '17px' }}>
                  <span className={classes.progressCurrently}>{formatThousands(progressPercentage, 0)}%</span>
                </div>
              )}
            </YumGrid>
          </>
        )}
      </div>
    </div>
  )
}
